<div class="container">
    <div class="insurer-authorization">
        <div class="insurer-authorization__header">
            {{ translationComponentKey + '.header' | translate }}
        </div>
        <div class="insurer-authorization__image">
            <img [src]="imageUrl">
        </div>
        <div class="insurer-authorization__text">
            <p>{{ translationComponentKey + '.text1' | translate}}</p>
            <p>{{ translationComponentKey + '.text2' | translate}}</p>
            <p>{{ translationComponentKey + '.text3' | translate}}</p>
            <div class="insurer-authorization__user">
                <div class="insurer-authorization__user--wrapper">
                    <div class="insurer-authorization__user--column">
                        <span> {{ translationComponentKey + '.firstName' | translate}} </span>
                        <span class="bold">{{status.firstName}}</span>
                    </div>
                    <div class="insurer-authorization__user--column">
                        <span>{{ translationComponentKey + '.lastName' | translate}} </span>
                        <span class="bold">{{status.lastName}}</span>
                    </div>
                    <div class="insurer-authorization__user--column">
                        <span>{{ translationComponentKey + '.address' | translate}} </span>
                        <span class="bold">
                            {{
                    status.address.postalCode + ' ' +
                    status.address.city +', ul. ' +
                    status.address.street + ' ' +
                    (status.address.buildingNumber ? status.address.buildingNumber : '') +
                    (status.address.flatNumber ? ' / ' + status.address.flatNumber: '')
                    }}
                        </span>
                    </div>
                </div>
            </div>
            <p class="font-12 text-underline text-italic">{{ translationComponentKey + '.text4' | translate}}</p>
            <p>{{ translationComponentKey + '.text5' | translate}}</p>
        </div>
        <div class="insurer-authorization__action">
            <div class="insurer-authorization__password">
                <div class="insurer-authorization__password--column">
                    <label class="insurer-authorization__label">
                        {{translationComponentKey + '.oneTimePassword' | translate}}
                    </label>
                </div>
                <div class="insurer-authorization__password--column">
                    <mat-form-field>
                        <input matInput [formControl]="smsCodeControl">
                        <mat-error *ngIf="!smsCodeControl.valid">
                            {{translationComponentKey + '.smsCodeError' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="insurer-authorization__buttons">
                <button class="btn btn--primary btn--outline" (click)="cancel()">
                    {{translationComponentKey + '.cancelButton' | translate}}
                </button>
                <button class="btn btn--secondary" (click)="confirm()">
                    {{translationComponentKey + '.confirmButton' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>